<template>
  <page-title pageTitle="Supplier" title="Edit Supplier" />
  <distributor-form
    v-if="distributor.id"
    :distributor="distributor"
    :submitFunction="editDistributor"
  />
  <div v-else class="card">
    <LoadingModal v-if="loading" />
    <div v-else-if="error" class="card-body">
      {{ error }}
    </div>
    <div v-else class="card-body">The distributor doesn't exist</div>
  </div>
</template>

<script>
import PageTitleComponent from "@/components/shared/PageTitle";
import DistributorForm from "@/components/distributor/DistributorForm";
import LoadingModalComponent from "@/components/utils/LoadingModal";

export default {
  name: "EditDistributorView",
  components: {
    PageTitle: PageTitleComponent,
    DistributorForm: DistributorForm,
    LoadingModal: LoadingModalComponent,
  },
  data() {
    return {
      id: -1,
    };
  },
  computed: {
    distributor() {
      return this.$store.getters.distributor;
    },
    error() {
      return this.$store.getters.distributorsError;
    },
    loading() {
      return this.$store.getters.distributorsLoading;
    },
  },
  methods: {
    async editDistributor(distributor) {
      await this.$store.dispatch("editDistributor", distributor);
      this.$router.push("/distributors");
    },
  },
  async created() {
    this.id = parseInt(this.$route.params.id);
    await this.$store.dispatch("getDistributor", this.id);
  },
  unmounted() {
    this.$store.dispatch("resetDistributor", this.id);
  },
};
</script>

<style scoped></style>
